import { loginAV2API } from 'services/redirectionApi';
import { openCloseToast } from 'components/Global/actions';
import { resetLoginState } from '../Login/actions';
import { setExpirationTokenDate } from 'helpers/setExpirationTokenDate.lib';

const destroyAV1Credentials = (dispatch) => {
  dispatch(resetLoginState());
  localStorage.removeItem('token');
};


export const loginAction = (user) => async (dispatch) => {
  try {
    const response = await loginAV2API(user);

    if (response.status === 200) {
      const result = await response.json();
      localStorage.setItem('id', user.id); 
      destroyAV1Credentials(dispatch);
      localStorage.setItem('Authorization', `Bearer ${result.accessToken}`);
      localStorage.setItem('roles-jwt', result.rolesTokens.accessToken);
      setExpirationTokenDate(`Bearer ${result.accessToken}`)
      setTimeout(() => {
        window.location.replace(`${process.env.REACT_APP_LINK_AV2_URL}inicio`);
      }, 1000)
    } else if (response.status === 400) {
      destroyAV1Credentials(dispatch);
      localStorage.setItem('blockedUser', '1');
      window.location.replace(`${process.env.REACT_APP_LINK_AV2_URL}achs/recupera-o-activa/ingresa-tu-rut`);
    } else {
      const result = await response.json();
      const toast = {};
      toast.isToastOpen = true;
      toast.msgToast = result.message;
      toast.typeStyle = 'error';
      toast.displayTime = 1000;
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    console.log('Selection action error: ', error.response);
  }
};
